import styled from "styled-components";
import logo from "../../../assets/imagens/logo-tour.png";
import React from "react";

const Wrapper = styled.div`
    position: fixed;
    left: -9999px;
    top: 0;
    width: 300px;
    background: #f7ecdc;
    font-family: "Jost", sans-serif;
`;

const Topo = styled.div`
    background: #421a10;
    color: #fff1e0;
    padding: 30px 20px;
    text-align: center;
`;

const Codigo = styled.div`
    font-size: 46px;
    font-weight: bold;
    margin-top: 10px;
`;

const Conteudo = styled.div`
    padding: 30px 20px;
    text-align: center;
    color: #5a2a1f;
`;

export const CupomImagem = ({ codigo, validade }, ref) => {
    return (
        <Wrapper ref={ref}>
            <Topo>
                <div>CUPOM</div>
                <Codigo>
                    {codigo.slice(0, 3)} {codigo.slice(3)}
                </Codigo>
            </Topo>

            <Conteudo>
                <img src={logo} width="150" alt="Tour Nugali" />

                <p>
                    Converta seu cupom e reserve seu ingresso no site
                    <br />
                    <strong>nugali.com.br/tickets</strong>
                </p>

                <p style={{ fontSize: 13 }}>
                    (ou presencialmente, sujeito à disponibilidade)
                </p>

                <p style={{ fontWeight: "bold", marginTop: 25 }}>
                    Válido até {validade}
                </p>
            </Conteudo>
        </Wrapper>
    );
};

export default React.forwardRef(CupomImagem);